import axios from "axios";

const baseURL = "https://mp.cpshelp.cn";

const axiosInst = axios.create({
  baseURL
});

export default axiosInst;
